<ng-container>
  <a [href]="'mailto:' + entry().email" [title]="getTitle()">
    @if (showEmailVerifyInformation()) {
      @if (entry().emailVerified === true) {
        &#x2713; {{ entry().email }}
      } @else {
        @if (!entry().emailVerified) {
          <em>? {{ entry().email }}</em>
        }
      }
    } @else {
      {{ entry().email }}
    }
  </a>
</ng-container>
